import { SingleAndMultiSelectFieldOption } from 'module/api/field/types';
import { QueryCombinerType, SimpleSearchFilter } from 'module/api/filter/types';
import { TableDataType } from 'module/ui/components/atoms/rich-text-editor/toolbar/table-toolbar';
import { GroupByOption } from 'api/custom-section/types';
import { AnswerTypeOption } from 'api/custom-section/types';
import { ParticipantGroupOption } from 'api/custom-section/types';
import { GenerateAsOption } from 'api/custom-section/types';
import { AnswerLength } from 'api/custom-section/types/question-answer-item';

export const defaultParticipantsFilter = {
  match: QueryCombinerType.All,
  nativeFields: [],
  customFields: [],
};

export interface PromptType {
  title: string;
  question?: string;
  aiContextChecked: boolean;
  aiContext?: string;
  generateAs: GenerateAsOption;
  groupBy: GroupByOption;
  participantsFilter: SimpleSearchFilter;
  participants: ParticipantGroupOption;
}
export type ActionPromptType = Omit<PromptType, 'question'>;
export type ExtractInfoPromptType = Omit<
  PromptType,
  'participantsFilter' | 'participants' | 'generateAs' | 'groupBy'
> & {
  choices: {
    answerType: AnswerTypeOption;
    choices: SingleAndMultiSelectFieldOption[];
    generateNewChoices: boolean;
  };
};

export type MultiQuestionPromptType = Omit<
  PromptType,
  | 'participantsFilter'
  | 'participants'
  | 'generateAs'
  | 'groupBy'
  | 'question'
  | 'aiContextChecked'
  | 'aiContext'
> & {
  questions: {
    label: string;
    value: number;
    position: number;
    fieldOptionMeta: {
      choices?: SingleAndMultiSelectFieldOption[];
      optionType: TableDataType;
      generateNewChoices?: boolean;
      aiContext?: string;
      id: string;
      answerFrom?: string;
      answerLength?: number | null;
    };
  }[];
};

export type QuestionAnswerItemPromptType = Omit<
  PromptType,
  | 'participantsFilter'
  | 'participants'
  | 'generateAs'
  | 'groupBy'
  | 'question'
  | 'aiContextChecked'
  | 'aiContext'
> & {
  questions: {
    label: string;
    value: number;
    position: number;
    fieldOptionMeta: {
      choices?: SingleAndMultiSelectFieldOption[];
      optionType: TableDataType;
      generateNewChoices?: boolean;
      aiContext?: string;
      id: string;
      answerFrom?: string;
      answerLength?: AnswerLength | null;
    };
  }[];
};

export type TableDetailsPromptType = Omit<
  PromptType,
  | 'participantsFilter'
  | 'participants'
  | 'generateAs'
  | 'groupBy'
  | 'question'
  | 'aiContextChecked'
  | 'aiContext'
> & {};

export type RecordBlockPromptType = Omit<
  PromptType,
  | 'participantsFilter'
  | 'participants'
  | 'generateAs'
  | 'groupBy'
  | 'question'
  | 'aiContextChecked'
> & {
  rowCriteria: string;
  filterExclusionCriteria: string;
};
